/**
 * Metric Logger for Sustainability Elements
 * Uses @amzn/exs-client-logging for CloudWatch metrics
 *
 * Note: @amzn/exs-client-logging provides built-in SSR support with stubs for Node environments,
 * so conditional imports are not needed.
 */

import { createMetricsLogger } from "@amzn/exs-client-logging/v2";
import { getCTIFromScriptUrl } from "./env.js";

// Determine CTI using script URL (more reliable than hostname check)
const cti = getCTIFromScriptUrl(import.meta.url);

// Type assertion needed until CTI is registered with Santos team
export const metricsLogger = createMetricsLogger(cti);
